<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="searchFor"
          label="Search"
          append-icon="search"
          @click:append="search"
          :rules="[rules.search]"
          :hint="hints.search()"
          @change="search"
          @keyup.native.enter="search">
        </v-text-field>
      </v-card-title>

      <v-data-table class="elevation-1"
                    :headers="headers"
                    :items="items"
                    :options.sync="pagination"
                    :server-items-length="totalItems"
                    :loading="loading"
                    v-if="state == 'list'"
                    :footer-props="footerProps"
                    @update:items-per-page="getItemPerPage"
      >

        <template v-slot:item="{ item }">
         <tr>
          <td class="text-xs-left">
            {{ item.id }}
          </td>

          <td class="text-xs-left">{{ item.name }}</td>
          <td class="text-xs-left">{{ item.containerType }}</td>
          <td class="text-xs-left">{{ getValue(item.containerType, item) }}</td>
          
          <td>
            <router-link :to="`/parcelnumbercontainers/${item.id}/tabs/container`">
              Open 
            </router-link>
          </td>
         </tr> 
        </template>
      </v-data-table>

<!-- Search Result -->

      <v-data-table class="elevation-1"
                    :headers="headers"
                    :items="items"
                    :options.sync="pagination"
                    :server-items-length="totalItems"
                    :loading="loading"
                    v-if="state == 'search'"
                    :footer-props="footerProps"
                    @update:items-per-page="getItemPerPage"
      >

        <template v-slot:item="{ item }">
         <tr>
          <td class="text-xs-left">{{ item.id }}</td>
          <td class="text-xs-left">{{ item.name }}</td>
          <td class="text-xs-left">{{ item.containerType }}</td>
          <td class="text-xs-left">{{ getValue(item.containerType, item) }}</td>

          <td>
            <router-link :to="`/parcelnumbercontainers/${item.id}/tabs/container`">
              Open
            </router-link>
          </td>
         </tr>
        </template>
      </v-data-table>

    </v-card>

    <v-dialog
      v-model="add_parcel_number_container_dialog"
      scrollable 
      :fullscreen="$vuetify.breakpoint.xsOnly"
      persistent :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
    <template v-slot:activator="{ on }">
      <v-btn color="success" v-on="on">Add</v-btn>
    </template>
     

      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.native="add_parcel_number_container_dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>New Parcel Number Container</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text :disabled="!pncType && !pncType" @click="savePnc()">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar> 
        
        <v-card-text>
          <span>Enter the Title and select a Location or Owner for the new Parcel Number Container.</span>

          <v-text-field
            v-model="pncTitle"
            label="Title"
          ></v-text-field>

          <v-input
            name="pnc_type"
            :value="pncType"
            single-line
            :messages="pncTypeMessages"
          >
           <v-expansion-panels>
              <isrs-pnc-type-card
                type="locationId"
                itemKey="0"
                itemText="name"
                itemValue="id"
                headline="Location"
                text="Explore hundreds of Locations ready to connect with this Parcel Number Container! For more information visit the Unique technical manual."
                :query="handleQueryLocations"
                @input="updateType"
                :fields="['id', 'code']"
              >
              </isrs-pnc-type-card>

              <isrs-pnc-type-card
                type="ownerId"
                itemKey="1"
                itemText="name"
                itemValue="id"
                headline="Owner"
                text="Restrict this Parcel Number Container to the following owner."
                :query="handleQueryOwners"
                @input="updateType"
                :fields="['code', 'id']"
              >
              </isrs-pnc-type-card>

              <isrs-pnc-type-card
                type="customerId"
                itemKey="2"
                itemText="customerName1"
                itemValue="customerId"
                headline="Customer"
                text="Only these customers can use this Parcel Number Container."
                :query="handleQueryCustomers"
                @input="updateType"
                :fields="['customerName1']"
              >
              </isrs-pnc-type-card>

              <isrs-pnc-type-card
                type="outboundOwnerId"
                itemKey="3"
                itemText="name"
                itemValue="id"
                headline="Outbound Owner"
                text="Select the owner for which the outbound parcel number container shall be created."
                :query="handleQueryOwners"
                @input="updateType"
                :fields="['code', 'id']"
              >
              </isrs-pnc-type-card>

              <isrs-pnc-type-card
                type="inboundOwnerId"
                itemKey="4"
                itemText="name"
                itemValue="id"
                headline="Inbound Owner"
                text="Select the owner for which the inbound parcel number container shall be created."
                :query="handleQueryOwners"
                @input="updateType"
                :fields="['code', 'id']"
              >
              </isrs-pnc-type-card>
           </v-expansion-panels>
          </v-input>
          
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-container>
</template>


<script>
  import axios from 'axios'
  import isoc from 'isoc'
  import DataService from '../services/data'

  import IsrsPncTypeCard from '../components/IsrsPncTypeCard.vue'

  export default {
    
    data () {
      return {
        
        dataService: undefined,
        items: [],
        pagination: {rowsPerPage: 10, showFirstLastPage: true},
        options:{sortBy:[], sortDesc:false, page:0, itemsPerPage:0},
        searchFor: '',
        footerProps: {
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageOptions: [10,20,40]
        },
        loading: true,
        totalItems: 0,
        searchFor: '',
        state: 'list',
        headline: '',
        footerProps: {
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageOptions: [10,20,40]
          },        
        headers: [
          {text: 'Id', value: 'id', sortable: false},
          {text: 'Name', value: 'name', sortable: false},
          {text: 'Type', value: 'type', sortable: false},
          {text: 'Value', value: 'customerId', sortable: false},
          {text: 'Actions', sortable: false}
        ],
        add_parcel_number_container_dialog: false,
        pncTitle: '',
        pncType: undefined,
        newPncTypesPanel: undefined,
        pncAutocompleteLocationSelected: undefined,
        pncAutocompleteLocationSearch: "",
        pncAutocompleteLocationLoading: false,
        pncAutocompleteLocationItems: [
        ],
        error: "",
        valid: true,
        rules: {
          search: () => this.valid || "Suchbegriff muss mindestens 3 Zeichen lang sein"
        },
        hints: {
          search: () => {
            return this.searchFor.length === 0 || this.searchFor.length > 2 ? "" : "Suchbegriff muss mindestens 3 Zeichen lang sein"
          }
        }
      }
    },

    components: {IsrsPncTypeCard},

     watch: {
      pagination: {
        handler: 'paginate',
        immediate: false
      },
      pncAutocompleteLocationSearch(val) {
        val && val !== this.select && this.pncAutocompleteLocationQuery(val)
      }
    },

    created () {
      this.dataService = new DataService(this.profile, this.$store.state.tokens)
    },

    computed: {
      payload () {
        return {
          name: this.container_name,
          customerId: this.container_customerid,
          contactId: this.container_contactid,
          depo: null,
          service: null,
          type: this.container_type
        }
      },
      pncTypeMessages() {
        if(this.pncType) {
          return Object.entries(this.pncType).map(([k, v]) => `${k}: ${v}`)
        } else {
          return ['no owner or location selected']
        }
      }
    },



    methods: {

      getItemPerPage(rows) {
        this.pagination.rowsPerPage = rows;
        this.paginate()
      },

      paginate() {

        if (this.searchFor) {

          return this.search(
            this.pagination.rowsPerPage,
            this.pagination.page,
            this.sortBy
          );
        }

        return this.fetchParcelNumberContainers(
          this.pagination.rowsPerPage,
          this.pagination.page,
          this.sortBy
        );
      },
      /**
        * Fetch the parcel number containers on page load
      */
      fetchParcelNumberContainers(size = 5, page = 1, sort = "id", descending = false) {
        this.loading = true;
        this.state = 'list';

        return this.dataService.getParcelNumberContainers(false, page, size, sort)
          .then(this.updateDataTable)
          .catch(err => {
              this.error = err;
              this.loading = false;
            }
          );
      },

      /**
        * Filter the parcel number containers as per the search input
      */
      search(size = 5, page = 0) {

        if (this.searchFor) {

          if (this.searchFor.length < 3) {
            this.valid = false;
            return false;
          }
           this.valid = true;

          this.state = 'search';
          this.loading = true;

          this.headline = `Suche : ${this.searchFor}`;

          this.dataService.searchParcelNumberContainers(this.searchFor, this.pagination.rowsPerPage, this.pagination.page, this.sortBy)
            .then(this.updateDataTable)
            .catch(err => {
              this.error = err;
              this.loading = false;
            });
 
        } else {
          this.resetSearch();
        }
      },
      resetSearch() {
         this.searchFor = "";
        this.state = 'list';
        this.headline = '';
        this.valid = true;
        this.paginate(); 
      },
      updateDataTable(result) {
        this.items = result.data.content;
        this.totalItems = result.data.totalElements;
        this.loading = false;
        return result;
      },      
      getItemPerPage(rows) {
        this.pagination.rowsPerPage = rows;
        this.queryPagination();
      },

      updateType(type) {
        this.pncType = type
      },

      pncAutocompleteLocationFilter(item, queryText, itemText) {
        return true
      },

      handleQueryLocations(val) {
        return this.dataService.getLocationsBySearchTerm(val).then( result => result.data.data)
      },

      handleQueryOwners(val) {
        return this.dataService.getOwnersBySearchTerm(val).then( result => result.data.data)
      },

      handleQueryCustomers(val) {
        return this.dataService.searchCustomers(val)
          .then( result => result.data.content)
      },

      pncAutocompleteLocationQuery(val) {
        this.pncAutocompleteLocationLoading = true
        this.dataService.getLocationsBySearchTerm(val).then( result => result.data.data).then( data => {
          this.pncAutocompleteLocationItems = data
          this.pncAutocompleteLocationLoading = false
        })
      },

      queryPagination () {
        let {sortBy, descending, page, rowsPerPage} = this.pagination

        if (descending) {
          sortBy = `${sortBy},desc`
        }

        if (this.dataService) {
          this.loading = true
          return this.dataService.getParcelNumberContainers(false, page, rowsPerPage, sortBy)
        }
        return Promise.reject('dataservice not ready')
      },

      updateDataTable (result) {
        this.loading = false
        this.items = result.data.content
        this.totalItems = result.data.totalElements
        return result
      },


      validateRequired (fieldName) {
        return (this[fieldName] && this[fieldName].length > 0) || 'This field is required'
      },

      validateMax (fieldName, max) {
        return (this[fieldName] && this[fieldName].length <= max) || `This field has a max length of ${max} characters`
      },

      savePnc() {
        const payload = Object.assign({name: this.pncTitle, type: "FIXME"}, this.pncType)

        this.dataService.addParcelNumberContainer(payload).then( result => {
          this.pncType = undefined
          this.pncType = ''
          this.add_parcel_number_container_dialog = false
          this.queryPagination().then(this.updateDataTable)
        })
      },

      getValue(type, item) {
        switch(type) {
          case 'OWNER': return item.ownerId
          case 'LOCATION': return item.locationId
          case 'CUSTOMER': return item.customerId
          case 'OUTBOUND': return item.outboundOwnerId
          case 'INBOUND': return item.inboundOwnerId
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ShowParcelNumberContainers.vue?58bf807b